export default "__VITE_ASSET__B$xpXVz0__"